<template>
    <div class="card akg-card">
        <div class="owerlay"></div>
        <div class="card-header">
            <form>
                <div class="form-row d-flex  align-items-center">
                    <div class="col-md-2 mb-2 mr-3">
                        <label for="validationServer01">Év</label>
                        <select2 class="form-control"
                                 :placeholder="'Év...'"
                                 :width="'100%'"
                                 v-model="selectedYear">
                            <option disabled
                                    value="0">--- Kezdeti év --</option>
                            <option v-for="year in years"
                                    v-bind:value="year.id">{{year.name }}</option>
                        </select2>
                        <small id="emailHelp"
                               class="form-text">A program kezdeti éve.</small>
                    </div>
                    <div class="col-md-3 mb-2 mr-1">
                        <label for="validationServer02">Program</label>
                        <select2 class="form-control"
                                 :placeholder="'Program...'"
                                 :disabled="programs.length == 0"
                                 :width="'100%'"
                                 v-model="selectedProgram">
                            <option disabled
                                    :value="0">-- Program --</option>
                            <option v-for="program in programs"
                                    v-bind:value="program.id">{{program.name }}</option>
                        </select2>
                        <small id="emailHelp"
                               class="form-text">Válassza ki a megfelelő programot!</small>
                    </div>
                    <div v-if="userProgramIsCreated"
                         class="col-md-1">
                        <span class="fa-stack info"
                              tabindex="0"
                              data-toggle="popover"
                              data-trigger="focus"
                              v-bind:title="program.name"
                              v-bind:data-content="program.description">
                            <i class="fa fa-circle-thin fa-stack-2x"></i>
                            <i class="fa fa-info fa-stack-1x"></i>
                        </span>
                    </div>
                    <div v-if="userProgramIsCreated"
                         class="export d-flex">
                        <i class="fa fa-file-excel-o download"
                           @click="exportToXls"
                           v-tooltip="'Exportálás xls-be.'"></i>

                    </div>
                    <agrotechnical-mechanism :selectedYear="selectedYear"
                                             :selectedProgram="program"
                                             :totalArea="totalArea"
                                             :sanctionCeckedYear="sanctionCeckedYear!=''?sanctionCeckedYear:null"
                                             :sanctionType="sanctionType"
                                             :userProgramId="typeof userProgram.id =='undefined'?null:userProgram.id"
                                             :isPeriodValidation="isPeriodValidation"
                                             @validateColumnSanctions="setYearlySanctionValidationResult"
                                             @validatePeriodSanctions="setPeriodSanctionValidationResult"
                                             @close="closeSettings"
                                             v-if="showAgrotechnicalMechanisms"></agrotechnical-mechanism>
                </div>
            </form>

        </div>
        <div v-if="loader"
             class="card-body">
            <custom-loader></custom-loader>
        </div>
        <div v-if="userProgramIsCreated"
             class="card-body">
            <div class="table-container-outer">
                <div class="table-container-fade"></div>

                <table id="#scroltable"
                       class="table table-sm table-scalable">
                    <thead class="thead-akg-head"
                           v-if='userProgram.kets.length>0'>
                        <tr>
                            <th colspan="2">
                                <div class="akg-tables-header-element">
                                    KET
                                </div>
                            </th>
                            <th v-for="n in 5"
                                colspan="5">
                                <div class='akg-tables-header-element'>{{parseInt(selectedYear)+n-1}}</div>
                            </th>
                            <th>
                                <div class="akg-tables-header-element">
                                    Vetésváltás
                                </div>
                            </th>
                        </tr>
                    </thead>

                    <tbody v-for="(ket, rowKey) in userProgram.kets">
                        <tr v-for="(row, keyR) in ket.rows"
                            class="ket-row">
                            <td colspan="2">
                                <ket-identification-name :ket="ket"
                                                         :isFirst="keyR==0"
                                                         @updated="removeValidations"></ket-identification-name>
                            </td>
                            <td class="akg-table"
                                v-for="(akg_table, key) in row.akg_tables"
                                colspan="5">
                                <akg-table :codes="codes"
                                           :ketArea="ket.area"
                                           :areaOne="row.akg_tables[0].area_one"
                                           :lastElement="key"
                                           :akgProgramId="userProgram.akg_program_id"
                                           :akgTableUnwatch="akgTableUnwatch"
                                           :akgTable="akg_table"
                                           :tables="row.akg_tables"
                                           @dragAndDropCopy="setDropedTableValuesForTheTargetTable"
                                           @updated="removeValidations"
                                           @setMagicCode="magicCodeUpdate"
                                           @unwatch="unwatchTables"
                                           @unSetMagicCode="unSetMagicCode"></akg-table>
                            </td>
                            <td align="center">
                                <tbody>
                                    <tr>
                                        <th>&nbsp;</th>
                                    </tr>
                                    <tr>
                                        <validate-ket-row :ketRowId="row.id"></validate-ket-row>
                                    </tr>

                                    <tr>
                                        <delete-ket-row :ketId="ket.id"
                                                        :ketRowId="row.id"
                                                        @deletedKetRow="deleteKetRow"></delete-ket-row>
                                    </tr>
                                </tbody>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                            </td>
                            <create-ket-row :ketId="ket.id"
                                            @createdKetRow="createKetRow"></create-ket-row>
                        </tr>
                    </tbody>
                    <tbody>
                        <tr>
                            <create-ket :userProgram="userProgram"
                                        @createdKet="createKet"></create-ket>

                            <td v-if="userProgram.kets.length > 0"
                                v-for="n in 5"
                                colspan="5">
                                <div class="row mx-auto">
                                    <div class="col-6 pr-1 pl-1">
                                        <b-btn variant="success"
                                               class="btn-sm btn-block "
                                               v-tooltip="parseInt(selectedYear)+n-1+' év ellenőrzése.'"
                                               v-on:click="validateColumn(parseInt(selectedYear)+n-1)">
                                            <i class="fa fa-check"
                                               aria-hidden="true"></i>
                                            Év ellenőrzése
                                        </b-btn>
                                    </div>
                                    <div class="col-6  pr-1 pl-0">
                                        <b-btn v-tooltip="parseInt(selectedYear)+n-1+' év szankcióinak az ellenörzése.'"
                                               variant="akg-warning"
                                               class="text-light btn-sm btn-block"
                                               v-on:click="validateColumnSanctions(parseInt(selectedYear)+n-1)">
                                            <i class="fa fa-check"
                                               aria-hidden="true"></i>
                                            Szankciók ellenőrzése
                                        </b-btn>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr v-if='userProgram.kets.length>0'>
                            <td colspan="2"></td>
                            <td colspan="25">
                                <div class="row mx-auto">
                                    <div class="col-12 pr-1 pl-1">
                                        <b-btn variant="akg-warning"
                                               class="btn-block btn-sm text-light"
                                               v-on:click="checkUserProgramSanctions()">
                                            <i class="fa fa-check"
                                               aria-hidden="true"></i>
                                            5 éves szankciók ellenőrzése
                                        </b-btn>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <transition name="fade"
                                    v-if='userProgram.kets.length>0'>
                            <akg-year-validations-result :programId="userProgram.akg_program_id"
                                                         :validations="userProgram.validations"
                                                         :startYear="parseInt(userProgram.year_start)"
                                                         :ketsLength="userProgram.kets.length"
                                                         v-if="this.userProgram.validations.length > 0">
                            </akg-year-validations-result>
                        </transition>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import swal from "sweetalert2";
import Select2 from "../components/Select2";
import CreateKet from "../components/CreateKet";
import CreateKetRow from "../components/CreateKetRow";
import DeleteKetRow from "../components/DeleteKetRow";
import ValidateKetRow from "../components/ValidateKetRow";
import KetIdentificationName from "../components/KetIdentificationName";
import AkgTable from "../components/AkgTable";
import UserProgram from "../moldels/UserProgram";
import AgrotechnicalMechanism from "../components/AgrotechnicalMechanism";
import AkgYearValidationsResult from "../components/AkgYearValidationsResult";
import CustomLoader from "../components/CustomLoader";

export default {
  name: "app",

  //uses
  components: {
    Select2,
    CreateKet,
    CreateKetRow,
    DeleteKetRow,
    ValidateKetRow,
    KetIdentificationName,
    AkgTable,
    AgrotechnicalMechanism,
    AkgYearValidationsResult,
    CustomLoader
  },

  //page properties

  data() {
    return {
      sanctionType: "all",
      sanctionCeckedYear: "",
      tableAreaModificatedAlert: true,
      akgTableUnwatch: false,
      loader: false,
      isPeriodValidation: false,
      codes: [],
      selectedCode: [],
      name: "",
      selectedYear: 0,
      years: [],
      selectedProgram: 0,
      program: "",
      programs: [],
      showAgrotechnicalMechanisms: false,
      userProgramIsCreated: false,
      userProgram: "",

      copyAction: new Form({
        tableId: "",
        targetTableId: ""
      })
    };
  },

  updated: function() {
    if ($(".table").parent(".table-responsive").length == 0) {
      this.$nextTick(function() {
        $(".table").scroltable();
      });
    }
  },

  computed: {
    totalArea: function() {
      var area = 0;
      loop1: for (let ket of this.userProgram.kets) {
        area = area + ket.area;
      }

      return area;
    }
  },

  beforeCreate() {
    UserProgram.fetchData(data => (this.years = data.years));
  },

  watch: {
    // whenever selected year changes, this function will run

    selectedYear: function(newYear) {
      this.seDefaultProperties();
      this.programs = "";
      this.selectedProgram = 0;

      UserProgram.getAllProgramsAnCodes(
        newYear,
        data => ((this.programs = data.programs), (this.codes = data.codes))
      );
    },

    // whenever selected program changes, this function will run

    selectedProgram: function(selctedProgram) {
      this.seDefaultProperties();
      if (selctedProgram == "") {
        return;
      }
      this.loader = true;

      this.program = _.find(this.programs, function(program) {
        return program.id == selctedProgram;
      });

      var vm = this;

      UserProgram.getUserProgramUsingByStartYearAndProgramId(
        this.selectedYear,
        this.selectedProgram,
        function(userProgram) {
          return vm.setAplicationProperties(userProgram);
        }
      );
    }
  },

  methods: {
    closeSettings() {
      this.isPeriodValidation = false;
      return (this.showAgrotechnicalMechanisms = false);
    },

    showAkgMechanisms(type) {
      this.sanctionType = type;
      return (this.showAgrotechnicalMechanisms = true);
    },

    getTableUsingById(id) {
      var existTable = "";

      loop1: for (let ket of this.userProgram.kets) {
        loop2: for (let row of ket.rows) {
          loop3: for (let table of row.akg_tables) {
            if (table.id == id) {
              existTable = table;
              break loop1;
            }
          }
        }
      }

      return existTable;
    },

    setDropedTableValuesForTheTargetTable(data) {
      var targetTable = this.getTableUsingById(data.targetTableId);

      if (targetTable == "") {
        return false;
      }

      this.copyAction.tableId = data.copyedTableId;
      this.copyAction.targetTableId = data.targetTableId;

      this.copyAction
        .post("ajax/akgTable/copyTableWithId")
        .then(function(data) {
          Object.assign(targetTable, data);
        })
        .catch(e => {
          console.log(e.errors);
        });
    },
    // Set default page properties

    seDefaultProperties() {
      this.program = "";
      this.sanctionType = "all";
      this.sanctionCeckedYear = "";
      this.showAgrotechnicalMechanisms = false;
      this.userProgramIsCreated = false;
      this.userProgram = "";
      this.loader = false;
    },

    //set pops if exist the user program

    setAplicationProperties(data) {
      let setData = new Promise((resolve, reject) => {
        let wait = setTimeout(() => {
          this.userProgramIsCreated = true;
          this.userProgram = data;
          this.loader = false;
          swal.close();
          resolve();
        }, 200);
      });

      var vm = this;
      setData.then(function(value) {
        vm.akgTableUnwatch = false;
      });
    },

    async recalculateAlert(year) {
      if (!this.tableAreaModificatedAlert) {
        return true;
      }

      var validated = false;

      loop1: for (let ket of this.userProgram.kets) {

        var yearlyTablesArea = 0;
        var ketArea = this.parseFloatValue(ket.area);

        loop2: for (let row of ket.rows) {

          var atad = false;

          loop3: for (let table of row.akg_tables) {



            if (table.year === year) {

              if (table.area_one !== null && table.area_one !== "") {
                yearlyTablesArea = yearlyTablesArea + this.parseFloatValue(table.area_one);
              }

              if (table.utilization_id_one == window.akgConstants.codeATAD && !atad) {
                    atad = true;
                    ketArea = ketArea-this.parseFloatValue(row.akg_tables[0].area_one);

                    if(table.area_one !==0){
                        yearlyTablesArea = yearlyTablesArea-this.parseFloatValue(row.akg_tables[0].area_one);
                    }
              }
            }
          }
        }

        if (ketArea !== yearlyTablesArea) {
          validated = true;
        }
      }

      if (validated) {
        const { value: accept } = await swal({
          type: "warning",
          title: "Figyelem!",
          input: "checkbox",
          confirmButtonColor: "#3fa535",
          html:
            "Kalkuláljon újra, mert a kiinduló  KET terület mérete nem egyezik a jelenlegi KET-en belüli összes tábla méretével, vagy válassza a KNK01 kódot - hozzárendelt területnagysággal - ha nem kért rá kifizetési kérelmet, vagy válassza az ATAD kódot, ha kizárt vagy átadott területei vannak.",
          inputValue: 0,
          inputPlaceholder: "Ne jelenjen meg többet ez az üzenet.",
          confirmButtonText: "Módosítom a kalkulációt",
          cancelButtonColor: "#bd9a44",
          cancelButtonText: "Kalkuláció futtatása a jelenlegi adatokkal",
          showCancelButton: true
        });

        if (accept == 1) {
          return (this.tableAreaModificatedAlert = false);
        }
        if (accept == 0) {
          return false;
        }

        return true;
      } else {
        return true;
      }
    },

    parseFloatValue(value){

        if (typeof value == "string") {
           value = value.replace(",", ".");
        }

        return parseFloat(value);

    },

    //yearly sanction vallidations
    validateColumnSanctions(year) {
      this.sanctionCeckedYear = year;
      this.sanctionType = "ANNUALLY";
      return (this.showAgrotechnicalMechanisms = true);
    },

    //period sanction vallidations
    checkUserProgramSanctions() {
      this.isPeriodValidation = true;
      this.sanctionCeckedYear = this.userProgram.year_start;
      this.sanctionType = "FULL_TIME";
      return (this.showAgrotechnicalMechanisms = true);
    },
    swalLoaderShow(text) {
      swal({
        title: "Kis türelmet!",
        confirmButtonColor: "#3fa535",
        text: text,
        allowOutsideClick: () => !swal.isLoading(),
        onOpen: () => {
          swal.showLoading();
        }
      });
    },
    //year vallidations

    validateColumn: _.debounce(
      async function(year) {
        var vm = this;

        if (await this.recalculateAlert(year)) {
          // this.swalLoaderShow(year + "- év kiértékelése folyamatban...");
          UserProgram.validateColumn(
            this.selectedProgram,
            this.userProgram.year_start,
            year,
            function(validationResult) {
              if (validationResult.status == "notValid") {
                swal({
                  type: "error",
                  title: "Hiba!",
                  html: validationResult.body,
                  confirmButtonColor: "#3fa535",
                  confirmButtonText: "Rendben"
                });
              }
              if (validationResult.status == 200) {
                vm.setValidationResult(validationResult);
                setTimeout(() => {
                  swal.close();
                  $.growl.notice({
                    title: "Sikeres mentés!",
                    message: "A módosítások mentése sikeresen megtörtént."
                  });
                }, 200);
              }
            }
          );
        }
      },
      // This is the number of milliseconds we wait for the
      // user to stop typing.
      50
    ),

    setYearlySanctionValidationResult(ids) {
      var vm = this;
      var year = this.sanctionCeckedYear;
      UserProgram.validateColumnSanctions(
        this.userProgram.id,
        this.sanctionCeckedYear,
        ids,
        function(validationResult) {
          if (validationResult.status == "notValid") {
            return swal({
              type: "error",
              title: "Hiba!",
              html: validationResult.body,
              confirmButtonColor: "#3fa535",
              confirmButtonText: "Rendben"
            });
          }
          if (validationResult.status == 200) {
            if (validationResult.body !== "") {
              swal({
                width: 1000,
                showCloseButton: true,
                showCancelButton: true,
                animation: false,
                html: validationResult.body,
                confirmButtonColor: "gray",
                cancelButtonColor: "#3fa535",
                confirmButtonText: "Letöltés <i class='fa fa-download'></i> ",
                cancelButtonText: "Rendben",
                cancelButtonAriaLabel: "Thumbs down"
              }).then(result => {
                if (result.value) {
                  vm.sanctionsExportToXls(year);
                }
              });
            } else {
              swal({
                type: "success",
                title: "Ok!",
                html: "Nincsenek szakciók.",
                confirmButtonColor: "#3fa535",
                confirmButtonText: "Rendben"
              });
            }
          }
        }
      );
    },

    setPeriodSanctionValidationResult(ids) {
      var vm = this;
      UserProgram.checkUserProgramSanctions(this.userProgram.id, ids, function(
        validationResult
      ) {
        if (validationResult.status == "notValid") {
          return swal({
            type: "error",
            title: "Hiba!",
            html: validationResult.body,
            confirmButtonColor: "#3fa535",
            confirmButtonText: "Rendben"
          });
        }
        if (validationResult.status == 200) {
          if (validationResult.body !== "") {
            swal({
              width: 1000,
              showCloseButton: true,
              showCancelButton: true,
              animation: false,
              html: validationResult.body,
              confirmButtonColor: "gray",
              cancelButtonColor: "#3fa535",
              confirmButtonText: "Letöltés <i class='fa fa-download'></i> ",
              cancelButtonText: "Rendben",
              cancelButtonAriaLabel: "Thumbs down"
            }).then(result => {
              if (result.value) {
                vm.sanctionsExportToXls();
              }
            });
          } else {
            swal({
              type: "success",
              title: "Ok!",
              html: "Nincsenek szakciók.",
              confirmButtonColor: "#3fa535",
              confirmButtonText: "Rendben"
            });
          }
        }
      });
    },

    sanctionsExportToXls(year) {
      this.swalLoaderShow("Az adatok exportálása folyamatban...");
      axios({
        url: "ajax/sanction_export",
        method: "post",
        data: {
          user_program_id: this.userProgram.id,
          year: year
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.xls");
        document.body.appendChild(link);
        swal.close();
        link.click();
      });
    },

    setValidationResult(validationResult) {
      this.userProgram.validations = validationResult.validations;
    },
    // callbac event if ket is created successfully

    createKet(newKet) {
      if (this.userProgram.kets.length == 0) {
        setTimeout(() => {
          $(".table").scroltable();
        }, 200);
      }

      this.userProgram.kets.push(newKet);
    },

    // callbac event if ket row is created successfully

    createKetRow(newRow) {
      var ket = _.find(this.userProgram.kets, function(ket) {
        return ket.id == newRow.ket_id;
      });

      ket.rows.push(newRow);
    },

    // callbac event if ket row is deleted successfully

    deleteKetRow(status, ketId, ketRowId) {
      if (status.status === "success") {
        var ket = _.find(this.userProgram.kets, function(ket) {
          return ket.id == ketId;
        });

        if (ket.rows.length === 1) {
          this.userProgram.kets.splice(this.userProgram.kets.indexOf(ket), 1);
        } else {
          var row = _.find(ket.rows, function(row) {
            return row.id == ketRowId;
          });

          ket.rows.splice(ket.rows.indexOf(row), 1);
        }
        this.removeValidations();
        swal({
          type: "success",
          title: "Sikeres törlés!",
          html: "Az aktuális sor törölve lett.",
          confirmButtonColor: "#3fa535",
          confirmButtonText: "Rendben"
        });
      }
    },

    // if user program akg tables data is changed removed old validations

    removeValidations(year = false) {
      if (!year) {
        if (this.userProgram.validations.length != 0) {
          this.userProgram.validations = [];
        }
        return;
      }
      var filteredValidations = _.filter(this.userProgram.validations, function(
        validation
      ) {
        return validation.year < year;
      });

      if (this.userProgram.validations.length != filteredValidations.length) {
        this.userProgram.validations = filteredValidations;
      }
    },

    unwatchTables() {
      this.akgTableUnwatch = true;
    },

    magicCodeUpdate(akgTableId) {
      this.swalLoaderShow("Az adatok beállítása folyamatban...");
      var vm = this;
      axios
        .post("ajax/akgTable/set_atad", {
          params: {
            akgTableId: akgTableId,
            userProgramId: this.userProgram.id
          }
        })
        .then(function(data) {
          vm.setAplicationProperties(data.data);
        })
        .catch(function(e) {
          alert("Hiba, valami elromlott, kérjük probálja újra kesőbb!");
        });
    },

    unSetMagicCode(akgTableId, utilizationId) {
      this.swalLoaderShow("Az adatok beállítása folyamatban...");
      var vm = this;
      axios
        .post("ajax/akgTable/unset_atad", {
          params: {
            akgTableId: akgTableId,
            userProgramId: this.userProgram.id,
            utilizationId: utilizationId
          }
        })
        .then(function(data) {
          vm.setAplicationProperties(data.data);
        })
        .catch(function(e) {
          console.log(e);
          alert("Hiba, valami elromlott, kérjük probálja újra kesőbb!");
        });
    },

    exportToXls() {
      this.swalLoaderShow("Az adatok exportálása folyamatban...");
      axios({
        url: "ajax/export",
        method: "post",
        data: {
          user_program_id: this.userProgram.id,
          to: "xls"
        },
        responseType: "blob" // important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "file.xls");
        document.body.appendChild(link);
        swal.close();
        link.click();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/AkgCalculator.vue